import { render } from "./course-information.vue?vue&type=template&id=2260073a&ts=true"
import script from "./course-information.vue?vue&type=script&lang=ts"
export * from "./course-information.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__